import classes from './Textarea.module.css';

interface ITextareaProps {
    label: string;
    errorText?: string;
    name: string;
    required?: boolean;
    placeholder: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    rows?: number;
    maxLength?: number;
    enableParagraphOnShiftEnter?: boolean;
}

const Textarea: React.FC<ITextareaProps> = ({
    label,
    errorText,
    name,
    required = false,
    placeholder,
    onChange,
    value,
    rows = 6,
    maxLength = 1200,
    enableParagraphOnShiftEnter = false,
}) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (enableParagraphOnShiftEnter && e.key === 'Enter' && e.shiftKey) {
            e.preventDefault();
            const target = e.currentTarget;
            const { selectionStart, selectionEnd, value, name } = target;
            const insertText = '\n\n';
            const newValue = value.slice(0, selectionStart) + insertText + value.slice(selectionEnd);
            const newPos = selectionStart + insertText.length;
            const syntheticEvent = {
                target: { name, value: newValue },
                currentTarget: { name, value: newValue },
            } as React.ChangeEvent<HTMLTextAreaElement>;
            onChange(syntheticEvent);
            requestAnimationFrame(() => {
                try {
                    target.selectionStart = target.selectionEnd = newPos;
                } catch {
                    // безопасный no-op
                }
            });

            return;
        }
    };

    return (
        <div className={classes.container}>
            <label className={classes.label} htmlFor={name}>
                {label} {required && <span className={classes.highlighted}>*</span>}
            </label>
            <textarea
                className={`${classes.textarea} ${errorText && classes.error}`}
                id={name}
                rows={rows}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onKeyDown={handleKeyDown}
                name={name}
                maxLength={maxLength}
            />
            {errorText && <span className={classes.highlighted}>{errorText}</span>}
        </div>
    );
};

export default Textarea;
